export default __webpack_public_path__ + "static/media/black-hole.66956cc9.svg";